var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.0703125,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#F0F2FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.75 16.9453H16.25C15.6287 16.9453 15.125 17.449 15.125 18.0703V27.0703C15.125 27.6916 15.6287 28.1953 16.25 28.1953H29.75C30.3713 28.1953 30.875 27.6916 30.875 27.0703V18.0703C30.875 17.449 30.3713 16.9453 29.75 16.9453ZM16.25 15.8203C15.0074 15.8203 14 16.8277 14 18.0703V27.0703C14 28.313 15.0074 29.3203 16.25 29.3203H29.75C30.9926 29.3203 32 28.313 32 27.0703V18.0703C32 16.8277 30.9926 15.8203 29.75 15.8203H16.25Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7758 24.0703L18.5 22.9497L23 18.0703L27.5 22.9497L26.2242 24.0703L23.75 21.3875V27.0703H22.25L22.25 21.3875L19.7758 24.0703Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenShare);
export default __webpack_public_path__ + "static/media/screenShare.8cbc34c8c2be9d1985cbd115c7aa7b7b.svg";
export { ForwardRef as ReactComponent };